module.exports = __webpack_public_path__ + "2bdaa46a5e40d57c24ef6ec3e97cd107.MP3";